import type { TypeFormFieldElement } from '../../types/form';
import extractFieldValues, { type TypeSerializedFieldEntry } from './extractFieldValues';

// ----------------------------------------------------------------------------

export type TypeSerializedArray = TypeSerializedFieldEntry[];

// ----------------------------------------------------------------------------

function serializeArray(form: HTMLFormElement): TypeSerializedArray {
    const elements = Array.from(form.elements) as TypeFormFieldElement[];

    return elements.flatMap((elField): any => extractFieldValues(elField));
}

// ----------------------------------------------------------------------------

export default serializeArray;
